import { useCallback, useMemo } from 'react';
import type { SlideData, VariantKey } from '../store/atoms/slideAtom';
import { isEditorSlideComplete, REQUIRED_VARIANTS } from '../utils/isSlideComplete';

export interface UseSlideIOParams {
  readonly slide: SlideData;
}

/**
 * Análise de completude do slide no editor.
 *
 * @param params - Slide em edição
 * @returns `canSave`, `getVariantCompleteness`
 */
export function useSlideIO({ slide }: UseSlideIOParams) {
  const canSave = useMemo(() => isEditorSlideComplete(slide.variants), [slide]);

  const getVariantCompleteness = useCallback((): Record<VariantKey, boolean> => {
    return Object.fromEntries(
      REQUIRED_VARIANTS.map(({ variantKey }) => [
        variantKey,
        slide.variants[variantKey]?.canvas != null,
      ]),
    ) as Record<VariantKey, boolean>;
  }, [slide]);

  return { canSave, getVariantCompleteness } as const;
}
